/** Turn an axios error into a user-facing message (FastAPI 422 details are arrays, not strings). */
export function apiError(err, fallback = "Something went wrong. Please try again.") {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 429) {
        return typeof d === "string" ? d : "Too many attempts. Please wait a few minutes and try again.";
    }
    return typeof d === "string" ? d : fallback;
}
